import { ref, computed, watch } from 'vue';
import type { StateViewModel } from './stateViewModel';
import type { PathViewModel } from './pathViewModel';
import { UPDATE_PATH } from '@/store/bot-designer/paths/mutationTypes';
import { store } from '@/store';

export function usePath(path: ref<PathViewModel>) {
  const states = ref<StateViewModel[]>(path.value.states);
  watch(
    () => path.value.states,
    () => (states.value = path.value.states),
    { deep: true },
  );

  function isEndState(state: StateViewModel) {
    return state.component === 'HumanHandover' || state.component === 'GoTo';
  }

  const reorderableStates = computed({
    get: () => states.value.filter((s: StateViewModel) => !isEndState(s)),
    set: (newList: StateViewModel[]) => {
      // Replace only the non-end states, preserve the end states
      const endStates = states.value.filter((s: StateViewModel) => isEndState(s));
      states.value = [...newList, ...endStates];

      path.value.states = states.value;
      store.commit(UPDATE_PATH, path);
    },
  });

  function getEndStates() {
    return states.value.filter((s: StateViewModel) => isEndState(s));
  }

  function hasEndingState() {
    return states.value.some((s: StateViewModel) => isEndState(s));
  }

  return {
    pathId: computed(() => path.value.id),
    pathName: computed(() => path.value.name),
    states,
    reorderableStates,
    hasEndingStates: computed(() => hasEndingState()),
    endStates: computed(() => getEndStates()),
  };
}
